/* import DefaultLayout from 'layouts/default'; */
import HomeLayout from 'layouts/home';
import './index.css';
import pcd from './pointcloud.jpg';
import teaser from './teaser3.jpg';
import sergeyLevine from './people/sergeylevine.png';
import ashvinnair from './people/ashvinnair.jpg';
import derekyang from './people/derekyang.jpg';
import fanboxiang from './people/fanboxiang.jpg';
import haosu from './people/haosu.jpg';
import leonidasguibas from './people/leonidasguibas.jpg';
import stonetao from './people/stonetao.jpg';
import tongzhoumu from './people/tongzhoumu.jpg';
import xuanlinli from './people/xuanlinli.jpg';
import zhanling from './people/zhanling.jpg';
import Qualcomm from './Qualcomm-logo-AI-research.png';
const ManiSkill2021HomePage = () => {
  return (
    <HomeLayout>
      <div className="ManiSkill2021">
        <div style={{ padding: '2rem' }}>
          <h2 style={{ fontSize: '3rem' }}>
            📣 The ManiSkill2 Challenge has released! Register now on{' '}
            <a href="https://sapien.ucsd.edu/challenges/maniskill2">
              our new website
            </a>
          </h2>
        </div>
        <div className="banner">
          <div
            className="banner-image"
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL + '/environments.jpg'
              })`,
            }}
          ></div>
          <div className="banner-text">
            <h1>SAPIEN ManiSkill Challenge 2021</h1>
          </div>
        </div>
        <div className="abcdef">
          <div className="content-left"></div>
          <div className="content">
            <div>
              {/* <h1>SAPIEN ManiSkill Challenge 2021</h1> */}
              {/* <video className="intro-video" controls>
                <source src="Maniskill_Challenge.mp4" type="video/mp4"/>
                Your browser does not support the video.
                </video> */}
              <div className="video-container">
                <iframe
                  src="https://www.youtube.com/embed/Lu8DJlnvYkA"
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div style={{ marginBottom: '10px' }}>
                Watch this video on{' '}
                <a
                  target="_blank"
                  href="https://www.bilibili.com/video/BV1N3411r7pu"
                >
                  Bilibili
                </a>
                .
              </div>
              <img src={pcd} className="teaser" />
              <img src={teaser} className="teaser" />
              <h2 id="challenge_results">Challenge Results</h2>
              <p>
                The final leaderboard and award information are available{' '}
                <a href="result">here</a>. They will be formally announced at
                our ICLR 2022 workshop{' '}
                <a
                  target="_blank"
                  href="https://ai-workshops.github.io/generalizable-policy-learning-in-the-physical-world/"
                >
                  Generalizable Policy Learning in the Physical World
                </a>
                .
              </p>
              <h2 id="intro">Introduction</h2>
              <p>
                At home, office, or other environments, we see the 3D world and
                manipulate objects surrounding us. Computer scientists today are
                interested in building artificial intelligence that can behave
                and interact with 3D objects as we humans do. To this end, we
                introduce SAPIEN Open-Source Manipulation Skill Challenge, or
                ManiSkill Challenge for short, an open-source challenge focusing
                on acquiring generalizable manipulation skills.
              </p>
              <p>
                ManiSkill challenge is built on the{' '}
                <a target="_blank" href="https://arxiv.org/abs/2107.14483">
                  <strong>SAPIEN Manipulation Skill Benchmark</strong>
                </a>{' '}
                (ManiSkill Benchmark), which utilizes a rich and diverse set of
                articulated objects to build 4 tasks. There are 162 objects for
                the 4 tasks in total. All tasks are equipped with high-quality
                demonstrations for learning-from-demonstrations approaches and
                we provide baseline algorithms. We believe this challenge will
                encourage the vision, learning, and robotics communities to
                explore generalizable object manipulation skills.
              </p>
              <p>
                Here we list the most important links for this challenge. More
                detailed descriptions are provided in later sections.
              </p>
              <ul>
                <li>
                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSeMzLHaTGTPCTYeIbo3TgWkjEtwJ21DEC-Bnr0JpR873pzeag/viewform?usp=sf_link">
                    Registration Form
                  </a>
                  : Use this form to inform us your team intends to participate.
                </li>
                <li>
                  <a href="https://github.com/haosulab/ManiSkill">
                    ManiSkill Benchmark
                  </a>
                  : the benchmark on which the participants compete.
                </li>
                <li>
                  <a href="https://github.com/haosulab/ManiSkill-Learn">
                    ManiSkill Learn
                  </a>
                  : Baseline algorithms we provided to solve the ManiSkill
                  Benchmark.
                </li>
                <li>
                  <a href="https://github.com/haosulab/ManiSkill-Submission-Example">
                    Submission Example
                  </a>
                  : An repo containing a sample submission.
                </li>
                <li>
                  <a target="_blank" href="https://arxiv.org/abs/2107.14483">
                    ManiSkill Benchmark White Paper
                  </a>
                  : arXiv paper describing the benchmark.
                </li>
                <li>
                  Follow{' '}
                  <a target="_blank" href="https://twitter.com/HaoSuLabUCSD">
                    @HaoSuLabUCSD
                  </a>{' '}
                  on Twitter to get news on the challenge.
                </li>
              </ul>
              <h2 id="policy">Open Source and Reproducibility Policy</h2>
              <p>
                ManiSkill Challenge is an open source challenge, meaning the
                teams winning awards must release their training code,
                evaluation code, and trained models. The code release happens
                after the end of the challenge. Teams who do not release code
                will not be considered for awards, but can stay on the
                leaderboard.
              </p>
              <p>
                After the challenge ends, if the community cannot reproduce the
                results from released code of any team, the team is supposed to
                address the concerns. If serious reproducibility issues are
                identified, the corresponding teams may be prohibited from
                participating in future ManiSkill challenges.
              </p>
              <h2 id="registration">Registration</h2>
              <p>
                There is no limit on how many people can be on each team. One
                participant is not allowed to join multiple teams. Fill out{' '}
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSeMzLHaTGTPCTYeIbo3TgWkjEtwJ21DEC-Bnr0JpR873pzeag/viewform?usp=sf_link">
                  this google form
                </a>{' '}
                if your team would like to participate.
              </p>
              <p>
                After we confirm your registration, you may use the login button
                on the top-right corner and register a SULab Auth account (our
                internal authentication system) to let you log in. Now you can
                submit to the challenges after the submission system is online.
              </p>
              <h2 id="timeline">Timeline</h2>
              <ul>
                <li>07/29/2021: Registration opens</li>
                <li>08/09/2021: Submission opens</li>
                <li>08/20/2021: Evaluation starts</li>
                <li style={{ textDecoration: 'line-through' }}>
                  12/10/2021: Challenge ends
                </li>
                <li style={{ textDecoration: 'line-through' }}>
                  12/17/2021: Code submission due
                </li>
                <li style={{ color: 'red' }}>01/14/2022: Challenge ends</li>
                <li style={{ color: 'red' }}>
                  01/21/2022: Code submission due
                </li>
              </ul>
              <h2 id="tracks">Challenge Tracks</h2>
              <p>
                The challenge has 3 tracks: <code>no interaction</code>,{' '}
                <code>no external annotation</code>, <code>no restriction</code>
                . Submissions for different tracks are handled through the same
                web page, and the participant can choose the track before
                submission. Here is a detailed explanation for each track.
              </p>
              <p>
                <code>no interaction</code> track requires the solution to only
                use the demonstration trajectories provided in this challenge.
                No interactions (i.e. additional trajectory collection, online
                training, etc.) are allowed.
              </p>
              <p>
                <code>no external annotation</code> track allows online
                fine-tuning with provided environments on top of the first
                track. However, the solution must not contain new annotations
                (e.g., new articulated objects from other dataset). The format
                of the agent should be similar to a network that takes
                observations and outputs actions.
              </p>
              <p>
                <code>no restriction</code> track allows the participants to do
                anything they want: labeling new data, creating new environment,
                etc. They are also allowed to hard-code manually designed
                control and planning rules to solve these problems with
                traditional robotics.
              </p>
              <h2 id="submission">Submission</h2>
              <p>
                Please refer to{' '}
                <a
                  href="https://github.com/haosulab/ManiSkill-Submission-Example"
                  target="_blank"
                >
                  this repo
                </a>
                .
              </p>
              <h2 id="eval">Evaluation</h2>
              <p>
                The evaluation has 2 stages. In the first stage (evaluated every
                week), the submissions are evaluated on 250 predetermined levels
                (each level corresponds to sampling all random variables in the
                environment using a fixed random seed) for each task. Among
                these 250 levels, 125 levels are evenly distributed over 5
                unseen objects in the test set, and the other 125 levels are
                evenly distributed over all objects in the training set. The
                score, defined as the Average Success Rate, is reported to the
                participants in the next week. In the second stage (evaluated
                after the end of the challenge), the submissions are evaluated
                on 250 more fixed levels for each task. Similarly, 125 levels
                come from the training set and the other 125 levels from the 5
                other unseen objects in the test set (different from the 5 test
                objects in stage 1). The final score is the average of scores of
                both stages.{' '}
                <b>
                  Note that this evaluation setup is easier than the setup
                  described in Sec 2.5 of our paper, because in the evaluation
                  setup you will face, we test on both seen and unseen objects.
                </b>
              </p>
              <p>
                Upon submission, we run 1 episode of testing immediately and
                report any errors encountered to verify the submission can
                execute successfully. After the verification is complete, we
                will execute this submission on the following Friday and you can
                expect results by the next Friday.
              </p>
              <p>
                Your submissions will first be in the <code>pending</code>{' '}
                state. If you make another submission to the same task and
                track, your previous <code>pending</code> submission will be
                discarded. When verified, your submission will be in the{' '}
                <code>verified</code> state. New submissions will not affect the
                state of previous <code>verified</code> submissions. After every
                Friday, we will evaluate all submissions in the past week that
                are
                <code>verified</code>, and hopefully report the evaluation
                scores by the next Friday. If a team has multiple verified
                submissions, only the latest one will be executed.
              </p>
              <p>
                Our evaluation environment consists of 1 single 2080Ti GPU, 10
                CPU threads, and 50G RAM. Your model must be able to execute
                under this configuration.
              </p>
              <h2 id="baselines">Baselines</h2>
              <table></table>
              <h2 id="awards">Awards</h2>
              <p>
                For each track (<code>no interaction</code>,{' '}
                <code>no external annotation</code>, <code>no restriction</code>
                )
              </p>
              <ul>
                <li>
                  1st place: <strong>3000 USD</strong>
                </li>
                <li>
                  2nd place: <strong>2000 USD</strong>
                </li>
                <li>
                  3rd place: <strong>1000 USD</strong>
                </li>
              </ul>
              <p>
                One team will only be considered for 1 award. If you participate
                in multiple tracks, your award will be in the track with highest
                ranking.
              </p>
              <p>
                In addition, to encourage diversity and inclusion, we grant up
                to 4 special awards taking into consideration of both team
                diversity and leaderboard ranking. Participants need to submit a
                diversity statement at the end of the challenge to be
                considered. The budget is <strong>2000 USD</strong> and will be
                split among the winning teams (e.g. if 4 teams are awarded, each
                gets 500 USD).
              </p>
              <h2 id="organizers">Organizing Committee</h2>
              <h3>Contributors</h3>
              <div className="people">
                <div className="person">
                  <img src={tongzhoumu} />
                  <div>Tongzhou Mu</div>
                  <div className="aff">UC San Diego</div>
                </div>

                <div className="person">
                  <img src={zhanling} />
                  <div>Zhan Ling</div>
                  <div className="aff">UC San Diego</div>
                </div>

                <div className="person">
                  <img src={fanboxiang} />
                  <div>Fanbo Xiang</div>
                  <div className="aff">UC San Diego</div>
                </div>

                <div className="person">
                  <img src={derekyang} />
                  <div>Derek Yang</div>
                  <div className="aff">UC San Diego</div>
                </div>

                <div className="person">
                  <img src={xuanlinli} />
                  <div>Xuanlin Li</div>
                  <div className="aff">UC San Diego</div>
                </div>

                <div className="person">
                  <img src={stonetao} />
                  <div>Stone Tao</div>
                  <div className="aff">UC San Diego</div>
                </div>
              </div>
              <h3>Counseling Committee</h3>
              <div className="people">
                <div className="person">
                  <img src={haosu} />
                  <div>Hao Su</div>
                  <div className="aff">UC San Diego</div>
                </div>

                <div className="person">
                  <div
                    style={{
                      borderRadius: '50%',
                      height: '150px',
                      width: '150px',
                      objectFit: 'cover',
                      overflow: 'hidden',
                    }}
                  >
                    <img
                      src={sergeyLevine}
                      style={{
                        transform: 'scale(2) translate(20px, 25px)',
                        width: '100%',
                        height: '100%',
                      }}
                    />
                  </div>
                  <div>Sergey Levine</div>
                  <div className="aff">UC Berkeley</div>
                </div>

                <div className="person">
                  <img src={ashvinnair} />
                  <div>Ashvin Nair</div>
                  <div className="aff">UC Berkeley</div>
                </div>

                <div className="person">
                  <img src={leonidasguibas} />
                  <div>Leonidas Guibas</div>
                  <div className="aff">Stanford</div>
                </div>
              </div>
              <h2 id="sponsor">Sponsor</h2>
              <div style={{ width: '300px' }}>
                <a
                  href="https://www.qualcomm.com/research/artificial-intelligence/ai-research"
                  target="_blank"
                >
                  <img src={Qualcomm} style={{ width: '400px' }} />
                  {/* <svg viewBox="0 0 783.6 144" xmlns="http://www.w3.org/2000/svg"><path d="M-125.7-125.7h1035v395.4h-1035z" fill="none"></path><path fill="rgb(50, 83, 220)" d="M211.5 41.3c2.1 0 3.9 1.7 3.9 3.9v74.5c0 2.1-1.9 3.8-3.9 3.8h-10.1c-1.9 0-3.8-1.5-3.8-3.6V113c-5.1 7.5-13.9 12.7-26.7 12.7-21.4 0-34.6-14.2-34.6-35.3V45c0-2.1 1.9-3.8 3.9-3.8h10.1c2.1 0 3.8 1.7 3.8 3.8v42.5c0 13.7 7.2 22.8 21.4 22.8 13.9 0 22.1-9.4 22.1-22.6V45c0-2.1 1.9-3.8 3.8-3.8h10.1M62.5 0C27.9 0 0 26.9 0 62.8c0 36 27.9 62.8 62.5 62.8 5.9 0 11.6-.8 17-2.3l6.8 17.5c.7 1.9 2.1 3.1 4.6 3.1h10.8c2.6 0 4.5-1.7 3.3-5L96.2 116c17.3-10.9 28.8-30.2 28.8-53.3C125 26.9 97.1 0 62.5 0m27.2 99.3l-7.9-20.5c-.7-1.7-2.1-3.3-5.1-3.3H66.4c-2.6 0-4.6 1.7-3.4 5l10.4 26.9c-3.4.9-7.1 1.3-10.9 1.3-25.3 0-43.3-19.9-43.3-45.9s18-45.9 43.3-45.9 43.3 19.9 43.3 45.9c0 15.2-6.1 28.2-16.1 36.5m693.6 20c.9 2.1-.2 4.1-2.7 4.1h-11.3c-2.1 0-3.8-1-4.5-3.1l-20.9-56.2-21.2 56.2c-.9 2.2-2.4 3.1-4.5 3.1h-10.1c-2.1 0-3.6-.9-4.5-3.1l-21.4-56.5-21.1 56.5c-.9 2.1-2.4 3.1-4.5 3.1H646c-2.1 0-3.6-1-4.5-3.1l-20.9-56.5-21.6 56.5c-.9 2.2-2.4 3.1-4.5 3.1h-10.1c-2.1 0-3.6-.9-4.5-3.1l-21.1-56.5-21.1 56.5c-.7 2.1-2.4 3.1-4.5 3.1h-11c-2.6 0-3.6-2.1-2.7-4.1l28.6-74.8c.9-2.2 2.4-3.3 4.5-3.3h12.3c2.1 0 3.6 1 4.5 3.3L590 99.1l20.4-54.6c.9-2.2 2.4-3.3 4.5-3.3H627c2.1 0 3.6 1 4.5 3.3l20.2 54.6 20.2-54.6c.9-2.2 2.4-3.3 4.5-3.3h12.2c2.1 0 3.6 1 4.5 3.3l20.5 54.6 20-54.6c.9-2.2 2.4-3.3 4.5-3.3h12.3c2.1 0 3.6 1 4.5 3.3l28.4 74.8m-473.9-78h-10.1c-2.1 0-3.9 1.7-3.9 3.9V52c-5.1-7.7-15.1-13.2-26.9-13.2-22.3 0-41.4 17.6-41.4 43.3 0 26 19.2 43.5 41.3 43.5 12 0 21.7-5.5 27.1-13.2v7.2c0 2.1 1.9 3.8 3.9 3.8h10.1c2.1 0 3.8-1.7 3.8-3.8V45.2c-.1-2.2-1.8-3.9-3.9-3.9m-39 67.9c-14.7 0-25.2-12-25.2-26.9 0-15.1 10.4-26.7 25.2-26.7 14.6 0 25.2 11.6 25.2 26.7-.1 15-10.7 26.9-25.2 26.9m159.5 2.6c2.2 2.7.3 4.8-.9 5.7-7 5.3-16.3 8.2-26.4 8.2-25.5 0-42.5-18.7-42.5-43.3s17-43.5 42.5-43.5c10.1 0 19.3 2.9 26.4 8.2 1.2.9 2.9 2.7.9 5.7l-4.8 6.7c-1.9 2.6-4.1 1.9-6 .7-4.5-2.7-9.8-5-15.9-5-14.9 0-24.8 12-24.8 27.2s9.9 27.1 24.8 27.1c6.2 0 11.1-2.4 15.6-5 1.9-1 3.9-1.9 6 .9l5.1 6.4zM477.5 39c-24 0-43.1 18.8-43.1 43.3 0 24.7 19.2 43.3 43.1 43.3 24 0 43.1-18.7 43.1-43.3.1-24.4-19.1-43.3-43.1-43.3m0 70.1c-14.7 0-25.2-11.8-25.2-26.7 0-15.1 10.4-26.7 25.2-26.7 14.7 0 25.2 11.6 25.2 26.7 0 14.9-10.4 26.7-25.2 26.7M344.8 2.2c2.2 0 3.8 1.9 3.8 3.9v113.4c0 2.1-1.5 3.9-3.8 3.9h-10.1c-2.1 0-3.9-1.9-3.9-3.9V6.2c0-2.1 1.9-3.9 3.9-3.9h10.1"></path></svg> */}
                </a>
              </div>
              <h2 id="contact">Contact</h2>
              For any questions, you may contact Tongzhou Mu at{' '}
              <a href="mailto:t3mu@eng.ucsd.edu">t3mu@eng.ucsd.edu</a>.
            </div>
          </div>
          <div className="content-right">
            <div className="toc">
              <h2>Table of contents</h2>
              <a href="#challenge_results">Challenge Results</a>
              <a href="#intro">Introduction</a>
              <a href="#policy">Open Source Policy</a>
              <a href="#registration">Registration</a>
              <a href="#timeline">Timeline</a>
              <a href="#tracks">Challenge Tracks</a>
              <a href="#submission">Submission</a>
              <a href="#eval">Evaluation</a>
              <a href="#awards">Awards</a>
              <a href="#organizers">Organizing Committee</a>
              <a href="#sponsor">Sponsor</a>
              <a href="#contact">Contact</a>
            </div>
          </div>
        </div>
      </div>
    </HomeLayout>
  );
};

export default ManiSkill2021HomePage;
